/* =====================================================================
   You Fly LA · header + mega menu "Postcard Deck B" (r14, 2026-09-30, theme v53) · assets/yfla-deck-menu.js
   Markup + data: snippets/yfla-deck-menu.liquid (every page) · styles: assets/yfla-deck-menu.css.

   Desktop (1200px and wider): each panel item is a <button aria-expanded aria-controls>. Opens on click, and on mouse hover
   after ~120 ms; closes on Esc (focus returns to the item), on a click outside the shell and when the mouse leaves the
   shell for ~200 ms. Moving between items swaps panels in place (no close / open). Rail tabs are toggle buttons
   (aria-pressed) that show one group; the preview shows the panel's own photo and copy until a card is hovered or
   focused, which puts that card's photo, title, description and price in it (a tab switch brings the panel's back).
   A panel's photos are requested only when it first opens. The panel is never taller than the viewport below the bar
   (the photos shrink to fit; it scrolls inside only as a last resort). Keyboard: Tab from an open item goes into its
   panel, Tab past the panel's last link goes on to the next item.
   Below 1200px: the Menu button opens the drawer under the bar (built once from the panels, so every link, group and
   price comes from the same markup): one accordion per menu, Simulator, Contact, Book A Discovery Flight, Book A
   Consultation and Call. Each link row carries a small thumbnail of its card photo, requested only when its menu is
   opened. Focus stays inside the header while it is open, Esc closes it, the page does not scroll.
   Also keeps #header-group's sticky top exact (the utility strip scrolls away, the bar stays 12px from the top).
   Global: window.YFLA_deckMenu only. Nothing here calls preventDefault on a link click, so assets/yfla-book.js, the
   weight/terms gate, the contact pop-up and #enroll keep working on these links.
   ===================================================================== */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var el = d.getElementById('yfdm');
  if (!el || el.getAttribute('data-yfdm-ready')) return;
  el.setAttribute('data-yfdm-ready', '1');

  var shell = el.querySelector('.yfdm-shell'), bar = el.querySelector('.yfdm-bar'), slot = el.querySelector('.yfdm-slot');
  var deck = d.getElementById('yfdm-deck'), drawer = d.getElementById('yfdm-drawer'), menubtn = el.querySelector('.yfdm-menubtn');
  var hdr = d.getElementById('header-group');
  var DESK = window.matchMedia('(min-width: 1200px)'), REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TEL = 'tel:+18183301318', PHONE = '(818) 330-1318';
  var open = '', openBy = '', tOpen = 0, tClose = 0, drawerOpen = false, raf = 0;

  function all(sel, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(sel)); }
  function panel(id) { return d.getElementById('yfdm-p-' + id); }
  function trigger(id) { return d.getElementById('yfdm-t-' + id); }
  var triggers = all('[data-yfdm-open]', el);
  function txt(node, sel) { var n = node.querySelector(sel); return n ? n.textContent.trim() : ''; }
  function visible(n) {
    if (!(n.offsetWidth || n.offsetHeight || n.getClientRects().length)) return false;
    return getComputedStyle(n).visibility !== 'hidden';
  }
  function focusables(scope) {
    return all('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])', scope).filter(visible);
  }
  function replay(node, cls) {
    if (REDUCE.matches) return;
    node.classList.remove(cls); void node.offsetWidth; node.classList.add(cls);
  }

  /* ---------- sticky offset + panel height ---------- */
  function stick() {
    if (!hdr) return;
    var gap = Math.round(shell.getBoundingClientRect().top - hdr.getBoundingClientRect().top);
    var top = -(gap - 12) + 'px';
    if (hdr.style.top !== top) hdr.style.top = top;
  }
  function fit() {
    var b = bar.getBoundingClientRect().bottom;
    el.style.setProperty('--yfdm-max', Math.max(200, Math.floor(window.innerHeight - b - 14)) + 'px');
  }
  function onScroll() {
    if ((!open && !drawerOpen) || raf) return;
    raf = requestAnimationFrame(function () { raf = 0; fit(); });
  }

  /* ---------- photos: requested only when a panel first opens ---------- */
  function loadImages(scope) {
    all('img[data-src]', scope).forEach(function (i) {
      if (i.getAttribute('data-srcset')) i.setAttribute('srcset', i.getAttribute('data-srcset'));
      i.setAttribute('src', i.getAttribute('data-src'));
      i.removeAttribute('data-src'); i.removeAttribute('data-srcset');
    });
  }

  /* ---------- the preview ---------- */
  function setPreview(p, card) {
    var pv = p.querySelector('.yfdm-pv');
    if (!pv) return;
    var src, set, alt, title, desc, price = '', was = '';
    if (card) {
      src = card.getAttribute('data-pv'); set = card.getAttribute('data-pvs'); alt = card.getAttribute('data-alt') || '';
      title = txt(card, '.yfdm-t'); desc = txt(card, '.yfdm-d');
      price = card.getAttribute('data-price') || ''; was = card.getAttribute('data-was') || '';
    } else {
      src = pv.getAttribute('data-src'); set = pv.getAttribute('data-srcset'); alt = pv.getAttribute('data-alt') || '';
      title = pv.getAttribute('data-title') || ''; desc = pv.getAttribute('data-desc') || '';
    }
    var key = src + '|' + title;
    if (pv.getAttribute('data-key') === key) return;
    pv.setAttribute('data-key', key);
    var img = pv.querySelector('.yfdm-pv__img');
    if (src && img.getAttribute('src') !== src) {
      if (set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      replay(img, 'is-in');
    }
    img.setAttribute('alt', alt);
    pv.querySelector('.yfdm-pv__t').textContent = title;
    var dn = pv.querySelector('.yfdm-pv__d');
    dn.textContent = desc; dn.hidden = !desc;
    var rv = pv.querySelector('.yfdm-rv');
    rv.hidden = !price;
    rv.querySelector('.yfdm-now').textContent = price;
    rv.querySelector('.yfdm-was').textContent = was;
  }
  /* the panel's own photo and copy (the design's default); a hovered or focused card replaces it */
  function groupDefault(p) { setPreview(p, null); }
  function showGroup(p, gi) {
    all('.yfdm-tab', p).forEach(function (t) { t.setAttribute('aria-pressed', String(t.getAttribute('data-g') === String(gi))); });
    all('.yfdm-grp', p).forEach(function (g) { g.hidden = g.getAttribute('data-g') !== String(gi); });
    all('.yfdm-card.is-hov', p).forEach(function (c) { c.classList.remove('is-hov'); });
    groupDefault(p);
  }

  /* ---------- open / close ---------- */
  function openPanel(id, by) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!DESK.matches || !panel(id)) return;
    if (open === id) { if (by === 'click') openBy = 'click'; return; }
    var was = open;
    open = id; openBy = by;
    triggers.forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-yfdm-open') === id)); });
    all('.yfdm-panel', deck).forEach(function (p) { p.hidden = p.id !== 'yfdm-p-' + id; });
    var p = panel(id);
    if (!p.getAttribute('data-loaded')) { p.setAttribute('data-loaded', '1'); loadImages(p); }
    showGroup(p, 0);
    deck.hidden = false;
    el.classList.add('is-open');
    if (!was) replay(deck, 'is-anim');
    fit();
    deck.scrollTop = 0;
  }
  function closePanel(refocus) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (!open) return;
    var id = open;
    open = ''; openBy = '';
    triggers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    deck.hidden = true;
    all('.yfdm-panel', deck).forEach(function (p) { p.hidden = true; });
    el.classList.remove('is-open');
    if (refocus && trigger(id)) trigger(id).focus();
  }

  triggers.forEach(function (b) {
    var id = b.getAttribute('data-yfdm-open');
    b.addEventListener('click', function () {
      if (open === id && openBy === 'click') closePanel(false);
      else openPanel(id, 'click');
    });
    b.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !DESK.matches) return;
      clearTimeout(tOpen); clearTimeout(tClose);
      if (open === id) return;
      tOpen = setTimeout(function () { openPanel(id, 'hover'); }, 120);
    });
    b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') clearTimeout(tOpen); });
  });
  /* the plain items (Simulator, Contact): resting on one closes an open panel */
  all('.yfdm-nav a.yfdm-nv', el).forEach(function (a) {
    a.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !open) return;
      clearTimeout(tOpen);
      tOpen = setTimeout(function () { closePanel(false); }, 120);
    });
    a.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') clearTimeout(tOpen); });
  });
  shell.addEventListener('pointerleave', function (e) {
    if (e.pointerType !== 'mouse' || !open) return;
    clearTimeout(tOpen); clearTimeout(tClose);
    tClose = setTimeout(function () { closePanel(false); }, 200);
  });
  shell.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(tClose); });

  /* cards: hover or focus -> preview; a card without a photo brings back the panel's own */
  function cardPreview(e) {
    var c = e.target.closest ? e.target.closest('.yfdm-card') : null;
    if (!c || !deck.contains(c)) return;
    var p = c.closest('.yfdm-panel');
    all('.yfdm-card.is-hov', p).forEach(function (x) { if (x !== c) x.classList.remove('is-hov'); });
    if (c.hasAttribute('data-pv')) { c.classList.add('is-hov'); setPreview(p, c); } else groupDefault(p);
  }
  deck.addEventListener('pointerover', cardPreview);
  deck.addEventListener('focusin', cardPreview);
  deck.addEventListener('click', function (e) {
    var t = e.target.closest('.yfdm-tab');
    if (t) { showGroup(t.closest('.yfdm-panel'), +t.getAttribute('data-g')); return; }
    var a = e.target.closest('a[href]');
    if (a && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey && e.button === 0) closePanel(false);
  });

  /* keyboard: into the panel from its item, out of it to the next item */
  el.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !open || drawerOpen) return;
    var p = panel(open), t = trigger(open), f = focusables(p), a = d.activeElement;
    if (!f.length) return;
    if (a === t && !e.shiftKey) { e.preventDefault(); f[0].focus(); }
    else if (a === t && e.shiftKey) { closePanel(false); }
    else if (a === f[0] && e.shiftKey) { e.preventDefault(); t.focus(); }
    else if (a === f[f.length - 1] && !e.shiftKey) {
      e.preventDefault();
      var li = t.closest('li'), next = li && li.nextElementSibling ? li.nextElementSibling.querySelector('a, button') : el.querySelector('.yfdm-cta');
      closePanel(false);
      if (next) next.focus();
    }
  });
  shell.addEventListener('focusout', function (e) {
    if (open && e.relatedTarget && !shell.contains(e.relatedTarget)) closePanel(false);
  });

  /* ---------- the drawer (below 1200px) ---------- */
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var ARROW = '<svg class="yfdm-arr" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true" focusable="false"><path d="M2 7h9M7.5 3.5L11 7l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg class="yfdm-chev" width="12" height="12" viewBox="0 0 10 10" aria-hidden="true" focusable="false"><path d="M2 3.5l3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function linkHTML(a, cls, inner) {
    var extra = a.hasAttribute('data-yfla-nocontact') ? ' data-yfla-nocontact' : '';
    return '<a class="' + cls + '" href="' + esc(a.getAttribute('href')) + '"' + extra + '>' + inner + '</a>';
  }
  function buildDrawer() {
    var h = '';
    all('.yfdm-nav__list > li', el).forEach(function (li) {
      var b = li.querySelector('[data-yfdm-open]');
      if (!b) { var a = li.querySelector('a'); if (a) h += linkHTML(a, 'yfdm-dl', esc(a.textContent.trim())); return; }
      var id = b.getAttribute('data-yfdm-open'), p = panel(id);
      if (!p) return;
      h += '<div class="yfdm-acc"><button type="button" class="yfdm-acc__b" aria-expanded="false" aria-controls="yfdm-acc-' + id + '"><span>' + esc(b.textContent.trim()) + '</span>' + CHEV + '</button><div class="yfdm-acc__p" id="yfdm-acc-' + id + '" hidden>';
      all('.yfdm-grp', p).forEach(function (g) {
        h += '<p class="yfdm-acc__g">' + esc(txt(g, '.yfdm-gt')) + '</p><ul>';
        all('.yfdm-card', g).forEach(function (c) {
          var pr = c.getAttribute('data-price') || '', was = c.getAttribute('data-was') || '';
          var price = pr ? '<span class="yfdm-pr">' + (was ? '<s><span class="yfdm-sr">Was </span>' + esc(was) + '</s> <span class="yfdm-sr">Now </span>' : '') + esc(pr) + '</span>' : '';
          var th = c.getAttribute('data-th');
          th = th ? '<span class="yfdm-acc__th"><img alt="" data-src="' + esc(th) + '" width="44" height="32" decoding="async"></span>' : '';
          h += '<li>' + linkHTML(c, 'yfdm-acc__l', th + '<span class="yfdm-acc__t">' + esc(txt(c, '.yfdm-t')) + '</span>' + price) + '</li>';
        });
        h += '</ul>';
      });
      var seen = {};
      all('[data-yfdm-extra]', p).forEach(function (x) {
        (x.tagName === 'A' ? [x] : all('a[href]', x)).forEach(function (a) {
          var k = a.getAttribute('href') + '|' + a.textContent.trim();
          if (seen[k]) return; seen[k] = 1;
          h += linkHTML(a, 'yfdm-acc__x', '<span>' + esc(a.textContent.trim()) + '</span>' + ARROW);
        });
      });
      var cta = p.querySelector('.yfdm-pv__cta');
      if (cta && !seen[cta.getAttribute('href') + '|' + cta.textContent.trim()]) h += linkHTML(cta, 'yfdm-acc__x', '<span>' + esc(cta.textContent.trim()) + '</span>' + ARROW);
      h += '</div></div>';
    });
    var bk = el.querySelector('.yfdm-cta');
    h += '<div class="yfdm-dctas"><a class="yfdm-dbtn yfdm-dbtn--fill" href="' + esc(bk ? bk.getAttribute('href') : '/products/discovery-flight-los-angeles') + '">' + esc(bk ? txt(bk, '.yfdm-cta__l') : 'Book A Discovery Flight') + '</a>'
      + '<a class="yfdm-dbtn yfdm-dbtn--line" href="/products/book-a-consultation">Book A Consultation</a>'
      + '<a class="yfdm-dbtn yfdm-dbtn--line" href="' + TEL + '">Call ' + PHONE + '</a></div>';
    drawer.innerHTML = h;
    drawer.setAttribute('data-built', '1');
    if (typeof window.YFLA_bookSweep === 'function') { try { window.YFLA_bookSweep(drawer); } catch (x) { /* booking links still work as plain links */ } }
  }
  function scroller() {
    var pw = d.querySelector('.page-wrapper');
    return pw && /auto|scroll/.test(getComputedStyle(pw).overflowY) && pw.scrollHeight > pw.clientHeight + 2 ? pw : null;
  }
  var locked = null;
  function lock(on) {
    if (on) {
      locked = scroller() || root;
      locked.style.overflow = 'hidden';
      root.setAttribute('scroll-lock', '');
    } else if (locked) {
      locked.style.overflow = '';
      locked = null;
      root.removeAttribute('scroll-lock');
    }
  }
  function setDrawer(v) {
    if (v === drawerOpen) return;
    if (v && DESK.matches) return;
    drawerOpen = v;
    if (v && !drawer.getAttribute('data-built')) buildDrawer();
    menubtn.setAttribute('aria-expanded', String(v));
    var l = menubtn.querySelector('.yfdm-menubtn__l');
    if (l) l.textContent = v ? 'Close' : 'Menu';
    drawer.hidden = !v;
    el.classList.toggle('is-drawer', v);
    lock(v);
    if (v) { fit(); drawer.scrollTop = 0; replay(drawer, 'is-anim'); }
  }
  menubtn.addEventListener('click', function () { setDrawer(!drawerOpen); });
  drawer.addEventListener('click', function (e) {
    var b = e.target.closest('.yfdm-acc__b');
    if (b) {
      var on = b.getAttribute('aria-expanded') === 'true';
      all('.yfdm-acc__b', drawer).forEach(function (x) { x.setAttribute('aria-expanded', 'false'); x.nextElementSibling.hidden = true; });
      if (!on) { b.setAttribute('aria-expanded', 'true'); b.nextElementSibling.hidden = false; loadImages(b.nextElementSibling); }
      return;
    }
    var a = e.target.closest('a[href]');
    if (a && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) setDrawer(false);
  });
  /* focus stays in the header (bar + drawer) while the drawer is open */
  shell.addEventListener('keydown', function (e) {
    if (!drawerOpen || e.key !== 'Tab') return;
    var f = focusables(shell);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = d.activeElement;
    if (e.shiftKey && (a === first || !shell.contains(a))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (a === last || !shell.contains(a))) { e.preventDefault(); first.focus(); }
  });
  d.addEventListener('focusin', function (e) { if (drawerOpen && !shell.contains(e.target)) menubtn.focus(); });

  /* ---------- global: Esc, outside click, scroll, resize ---------- */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (open) closePanel(true);
    if (drawerOpen) { setDrawer(false); menubtn.focus(); }
  });
  d.addEventListener('pointerdown', function (e) {
    if (shell.contains(e.target)) return;
    if (open) closePanel(false);
    if (drawerOpen) setDrawer(false);
  }, true);
  d.addEventListener('scroll', onScroll, { capture: true, passive: true });
  var tR = 0;
  window.addEventListener('resize', function () {
    clearTimeout(tR);
    tR = setTimeout(function () { stick(); if (open || drawerOpen) fit(); }, 100);
  });
  function onBreak() { closePanel(false); setDrawer(false); stick(); }
  if (DESK.addEventListener) DESK.addEventListener('change', onBreak); else if (DESK.addListener) DESK.addListener(onBreak);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(stick);
  window.addEventListener('load', stick);
  stick();

  window.YFLA_deckMenu = { version: 'r19', open: function (id) { openPanel(id, 'click'); }, close: function () { closePanel(false); setDrawer(false); }, drawer: setDrawer, state: function () { return { open: open, drawer: drawerOpen }; } };
})();
